class Utils {

    // █████ █████ █     █████ █████ ████        ████   ███  █████  ███  
    // █       █   █       █   █     █   █       █   █ █   █   █   █   █ 
    // ████    █   █       █   ████  ████        █   █ █████   █   █████ 
    // █       █   █       █   █     █   █       █   █ █   █   █   █   █ 
    // █     █████ █████   █   █████ █   █       ████  █   █   █   █   █ 


    processArrays(arrData, arrIds, arrNames) {
        try {
            let dataArr = [];

            for (let i = 0; i < arrData.length; i++) {
                let data = {
                    name: arrData[i],
                    ids: arrIds,
                    value: countVal
                };
                dataArr.push(data);

            }
            let returnValue = {
                "status": "success",
                "message": "Plot added.",
                "data": dataArr
            }
            return returnValue;
        }
        catch (err) {
            let returnValue = {
                "status": "failed",
                "message": "Plot not added." + err.message,
                "data": dataArr
            }
            return returnValue;
        }

    }

    filterOtherTypeData(newData, keyId, keyGroup) {
        try {
            let dataObj = {};
            let dataArr = [];
            let keys = [];

            for (let i = 0; i < newData.length; i++) {
                let key = newData[i][keyGroup];

                if (key) {
                    if (!keys.includes(key)) {
                        let data = {
                            key: key,
                            value: 0,
                            ids: [],
                        }

                        keys.push(key);
                        dataArr.push(data)
                    }
                    let j = keys.indexOf(key);

                    dataArr[j].value = dataArr[j].value + 1;
                    dataArr[j].ids.push(newData[i][keyId])
                }
            }

            let settings = {
             min: 0,
             max: Math.max.apply(Math, dataArr.map(function(o) { return o.value; })),
            }

            dataObj.data = dataArr;
            dataObj.settings = settings;
            
            let returnValue = {
                "status": "success",
                "message": "Plot added.",
                "data": dataObj
            }
            return returnValue;
        }
        catch (err) {
            let returnValue = {
                "status": "failed",
                "message": "Plot not added." + err.message,
                "data": dataObj
            }
            return returnValue;
        }
    }

    filterNumberTypeData(newData, keyId, keyGroup, keySum) {
        try {
            if (keySum == undefined) keySum = keyId;

            let dataObj = {};
            let dataArr = [];
            let keys = [];

            for (let i = 0; i < newData.length; i++) {
                let idsArr = [];
                let sum = newData[i][keySum];
                let key = newData[i][keyGroup];

                if (sum && key) {
                    idsArr.push(newData[i][keyId])
                    if (!keys.includes(key)) {

                        let data = {
                            key: key,
                            value: sum,
                            ids: idsArr,
                        };
                        dataArr.push(data);
                        keys.push(key);
                    }
                    else {
                        dataArr[keys.indexOf(key)].value = parseFloat(dataArr[keys.indexOf(key)].value) + parseFloat(sum);
                        dataArr[keys.indexOf(key)].ids.push(newData[i][keyId]);
                    }
                }
            }

            let settings = {
             min: Math.min.apply(Math, dataArr.map(function(o) { return o.value; })),
             max: Math.max.apply(Math, dataArr.map(function(o) { return o.value; })),
            }

            settings.min = settings.min-(settings.min/10.0)

            dataObj.data = dataArr;
            dataObj.settings = settings;

            let returnValue = {
                "status": "success",
                "message": "Plot added.",
                "data": dataObj
            }
            return returnValue;
        }
        catch (err) {
            let returnValue = {
                "status": "failed",
                "message": "Plot not added." + err.message,
                "data": dataObj
            }
            return returnValue;
        }
    }

    filterScatterData(newData, keyId, keyX, keyY, radius = 4) {
        try {
            let dataArr = [];
            for (let i = 0; i < newData.length; i++) {

                let x = newData[i][keyX];
                let y = newData[i][keyY];

                if (x && y) {
                    let data = {
                        key: x,
                        value: x,
                        ids: newData[i][keyId],
                        x: x,
                        y: y,
                        r: radius,
                    };
                    dataArr.push(data);
                }
            }

            let returnValue = {
                "status": "success",
                "message": "Plot added.",
                "data": dataArr
            }
            return returnValue;
        }
        catch (err) {
            let returnValue = {
                "status": "failed",
                "message": "Plot not added." + err.message,
                "data": dataArr
            }
            return returnValue;
        }
    }

    filterBubbleData(newData, keyId, keyX, keyY, keyRadius, minRadius = 4, maxRadius = 8) {
        try {
            let dataArr = [];
            let radi = [];
            for (let i = 0; i < newData.length; i++) {

                let x = newData[i][keyX];
                let y = newData[i][keyY];
                let r = newData[i][keyRadius];

                if (x && y && r) {
                    let data = {
                        key: x,
                        value: x,
                        ids: newData[i][keyId],
                        x: x,
                        y: y,
                    };
                    radi.push(Number(r));
                    dataArr.push(data);
                }
            }

            //Remap each radius value to the min and max radi
            let minR = Math.min(...radi);
            let maxR = Math.max(...radi);
            for (let i = 0; i < dataArr.length; i++)  dataArr[i].r = this.remap((radi[i] - minR) / (maxR - minR), minRadius, maxRadius);

            let returnValue = {
                "status": "success",
                "message": "Plot added.",
                "data": dataArr
            }
            return returnValue;
        }
        catch (err) {
            let returnValue = {
                "status": "failed",
                "message": "Plot not added." + err.message,
                "data": dataArr
            }
            return returnValue;
        }
    }

    filterLineData(newData, keyId, keyGroup, keySort) {
        try {
            let dataObj = {};
            let dataArr = [];
            let keysArr = [];
            let values = [];
            let steps = [];

            let sortingData = newData.slice();
            if (keySort) sortingData.sort((a, b) => parseFloat(a[keySort]) - parseFloat(b[keySort]));

            let updatedData = [];
            for (let i = 0; i < sortingData.length; i++) {
                let validKeys = []
                keyGroup.forEach(key => {
                    if (sortingData[i][key]) validKeys.push(true)
                });
                if (validKeys.includes(true)) updatedData.push(sortingData[i])
            }
        
            for (let i = 0; i < updatedData.length; i++) {
                steps.push(i);
            }

            keyGroup.forEach(key => {
                let ids = [];
                let nonNullValues = []
                let maxIndex = 0
                for (let i = 0; i < updatedData.length; i++) {
                    let value = updatedData[i][key];
                    if (value){
                        let data = {
                            key: key,
                            value: value,
                            ids: updatedData[i][keyId],
                            x: i,
                            y: value,
                        };
                        nonNullValues.push(Number(value));
                        values.push(Number(value))
                        dataArr.push(data);
                        ids.push(updatedData[i][keyId]);
                        maxIndex = i
                    }
                }
                //Create keys used to plot lables next to lines
                let keyInfo = {
                    key: key,
                    ids: ids,
                    x: maxIndex, 
                    y: nonNullValues[nonNullValues.length - 1], 
                };
                keysArr.push(keyInfo);
            });

            let settings = {
                min: Math.min(...values),
                max: Math.max(...values),
                steps: steps,
                total: updatedData.length,
            };

            dataObj.data = dataArr;
            dataObj.keys = keysArr;
            dataObj.settings = settings;

            let returnValue = {
                "status": "success",
                "message": "Plot added.",
                "data": dataObj
            }
            return returnValue;
        }
        catch (err) {
            let returnValue = {
                "status": "failed",
                "message": "Plot not added." + err.message,
                "data": dataArr
            }
            return returnValue;
        }
    }

    filterParallelCoordinate(newData, keyId, keyAxis, axisTypes) {
        try {
            let dataObj = {};
            let dataArr = [];
            let axisArr = {};


            keyAxis.forEach(key => {
                axisArr[key] = { values: [] };
            });

            newData.forEach(entry => {
                let data = { id: entry[keyId] };
                let valid = true;
                keyAxis.forEach(key => {
                    let value = entry[key];
                    
                    if (value && (value != NaN) && (value != null)) {
                            data[key] = entry[key];
                            axisArr[key].values.push(entry[key]);
                    }
                    else {
                        data[key] = null;
                        axisArr[key].values.push(null);
                    }
                });
                if (valid === true) dataArr.push(data);
            });

            keyAxis.forEach((key, i) => {
                if (axisTypes[i] == "number") {
                    const min = Math.min(...axisArr[key].values);
                    axisArr[key].values = axisArr[key].values.map(item => item === null ? (min-1.0) : item);
                    
                    axisArr[key].type = "value";
                    axisArr[key].min = Math.min(...axisArr[key].values);
                    axisArr[key].max = Math.max(...axisArr[key].values);
                    axisArr[key].set = [];
                }
                else {
                    axisArr[key].type = "point";
                    axisArr[key].values = axisArr[key].values.map(item => item === null ? "_empty" : item);

                    axisArr[key].set = [...new Set(axisArr[key].values)].sort();
                    axisArr[key].min = 0;
                    axisArr[key].max = axisArr[key].set.length - 1;
                }
            });

            keyAxis.forEach((key, i) => {
                newData.forEach((entry, j) => {
                    dataArr[j][key] = axisArr[key].values[j];
                });
            });

            dataObj.axis = axisArr;
            dataObj.data = dataArr;

            let returnValue = {
                "status": "success",
                "message": "Plot added.",
                "data": dataObj
            }

            return returnValue;
        }
        catch (err) {
            let returnValue = {
                "status": "failed",
                "message": "Plot not added." + err.message,
                "data": dataObj
            }
            return returnValue;
        }
    }


    // █████ █████ █   █ █     █████ █   █  ████ 
    // █       █    █ █  █       █   ██  █ █     
    // █████   █     █   █       █   █ █ █ █  ██ 
    //     █   █     █   █       █   █  ██ █   █ 
    // █████   █     █   █████ █████ █   █  ███  


    defaultFormatting = { xGrid: true, yGrid: false, xAxis: true, yAxis: false, xLabel: true, yLabel: true };

    partialFillPattern(canvas, color) {
        canvas
            .append('defs')
            .append('pattern')
            .attr('id', 'diagonalHatch')
            .attr('patternUnits', 'userSpaceOnUse')
            .attr('width', 4)
            .attr('height', 8)
            .attr('patternTransform', 'rotate(-45 2 2)')
            .append('path')
            .attr('d', 'M -1,2 l 6,0')
            .style("stroke", color)
            .style("stroke-width", "7")
            .style('stroke-opacity', '1.0');
    }

    formatTooltipDefault(tooltip, color) {

        tooltip
            .attr("class", "tooltip")
            .style("position", "absolute")
            .style("opacity", 0)
            .style("font-size", "12px")
            .style("background-color", color)
            .style("border", 'none')
            .style("border-radius", '3px')
            .style("padding", '5px')
            .style("text-align", 'left')
            .style("color", 'white');
    }

    formatTooltipMove(pointer, tooltip, canvasWidth, canvasHeight) {
        const tooltipMargin = 10; // Margin between the tooltip and the edges
        const tooltipWidth = tooltip.node().offsetWidth;
        const tooltipHeight = tooltip.node().offsetHeight;
      
        let left = pointer[0] + tooltipMargin;
        let top = pointer[1] + tooltipMargin;
      
        // Adjust left position if tooltip goes beyond the right edge
        if (left + tooltipWidth + tooltipMargin > canvasWidth) {
          left = pointer[0] - tooltipWidth - tooltipMargin;
        }
      
        // Adjust top position if tooltip goes beyond the bottom edge
        if (top + tooltipHeight + tooltipMargin > canvasHeight) {
          top = pointer[1] - tooltipHeight - tooltipMargin;
        }
      
        // Adjust left position if tooltip goes beyond the left edge
        if (left < tooltipMargin) {
          left = tooltipMargin;
        }
      
        // Adjust top position if tooltip goes beyond the top edge
        if (top < tooltipMargin) {
          top = tooltipMargin;
        }
      
        tooltip
          .style("left", left + "px")
          .style("top", top + "px");
    }

    formatTooltipOn(tooltip) {
        tooltip
            .transition()
            .duration(500)
            .style("opacity", 1)
            .style("visibility", "visible");
    }

    formatTooltipOff(tooltip) {
        tooltip
            .transition()
            .duration(500)
            .style("opacity", 1)
            .style("visibility", "hidden");
    }

    formatAxis(element, visible, color, opacity = 1.0, angle = 0) {
        //Formatting
        element.attr('color', color)
            .style("opacity", opacity);

        //Selection Events
        element.style("stroke", 'transparent')
            .style('pointer-events', 'none') // restricted mouse events
            .style('user-select', 'none') // stanard
            .style('-webkit-user-select', 'none') // safari 
            .style('-ms-user-select', 'none'); // IE10 and IE11
            
        if (angle != 0) {
            element.selectAll('text')
                .style('text-anchor', 'end') // aligns the text so that its right edge is at x
                .attr('transform', function() {
                // Get the bounding box for the current text element
                let bbox = this.getBBox();
                // Rotate text around the top right corner: x + width, and y (top)
                let cx = bbox.x + bbox.width;
                let cy = bbox.y;
                return `rotate(${-angle}, ${cx}, ${cy})`;
                })
        }
        if (visible == false) element.call(g => g.selectAll("path,line").attr("stroke", 'transparent'));
    }

    formatGrid(element, visible, color, opacity = 1.0) {
        if (!element || !element.style) return 
        //Formatting
        element.style("opacity", opacity);

        //Selection Events
        element.style('pointer-events', 'none') // restricted mouse events
            .style('user-select', 'none') // stanard
            .style('-webkit-user-select', 'none') // safari
            .style('-ms-user-select', 'none');

        element.call(g => g.selectAll("line")
            .attr("class", "axis_grid")
            .attr("stroke", color));

        element.call(g => g.selectAll("path")
            .attr("display", "none"));

        if (visible == false) element.call(g => g.selectAll("*").attr("display", "none"));
    }

    defaultItem(element, tooltip, color, opacity = 1.0) {
        let scope = this;

        element
            .attr("data-isSel", false)
            .attr("data-isPar", false)
            .attr("data-isClr", false)
            .style("opacity", opacity)
            .attr("data-color", color)
            .on("mouseover", function (d) { scope.formatTooltipOn(tooltip) })
            .on("mouseleave", function (d) { scope.formatTooltipOff(tooltip) })
    }

    formatFillItem(element, tooltip, color, opacity = 1.0) {
        let scope = this;

        element
            .attr('fill', color);
        scope.defaultItem(element, tooltip, color, opacity)
    }

    formatStrokeItem(element, tooltip, color, opacity = 1.0) {
        let scope = this;

        element
            .attr('stroke', color);
        scope.defaultItem(element, tooltip, color, opacity)
    }


    // █   █ █████ █████ █     █████ █████ █████ █████ █████ 
    // █   █   █     █   █       █     █     █   █     █     
    // █   █   █     █   █       █     █     █   ████  █████ 
    // █   █   █     █   █       █     █     █   █         █ 
    // █████   █   █████ █████ █████   █   █████ █████ █████ 


    uniqueValues(newData, key) {
        try {
            let tempArr = [];
            for (let i = 0; i < newData.length; i++) {
                if (newData[i][key]) tempArr.push(newData[i][key])
            }
            let dataArr = tempArr.filter((value, index, array) => array.indexOf(value) === index);
            dataArr.sort();
            let returnValue = {
                "status": "success",
                "message": "Plot added.",
                "data": dataArr
            }

            return returnValue;
        }
        catch (err) {
            let returnValue = {
                "status": "failed",
                "message": "Plot not added." + err.message,
                "data": dataArr
            }
            return returnValue;
        }
    }

    remap(value, min, max) {
        return Number(min) + Number((max - min) * value);
    }

    isDark(color) {
        var r, g, b, rgb, hsp;

        rgb = color.substring(4, color.length - 1)
            .replace(/ /g, '')
            .split(',');

        r = rgb[0];
        g = rgb[1];
        b = rgb[2];

        hsp = Math.sqrt(
            0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b)
        );

        if (hsp > 150) {
            return '#000000';
        }
        else {

            return '#ffffff';
        }

    }

    computeTextRotation(d) {
        var rotation = (d.startAngle + d.endAngle) / 2 * 180 / Math.PI - 90;
        return {
            global: rotation,
            correction: rotation > 90 ? 180 : 0
        };
    }

    setDigits(value, places) {
        const factor = Math.pow(10, places);
        let val = value;
        if (!isNaN(value)) val = Math.round(value * factor) / factor;
        return val;
    }

    //Gets the max num of chars of an array of values. Ex [874, 3895, 89] returns 4  
    getMaxCharactersForNumber(values){
        const parsedValues = values
            .map(value => parseFloat(value))
            .filter(num => !isNaN(num));
        if (parsedValues.length === 0) return 0;
        const maxValue = Math.max(...parsedValues.map(Math.abs));
        return maxValue > 0 ? Math.floor(Math.log10(Math.abs(maxValue))) + 1 : 0;
    }

    //Gets the max num of chars of an array of strings. Ex ['hi', 'bye', 'hello'] returns 5   
    getMaxCharactersForString(values){
        return values.map(value => value.length).reduce((max, num) => Math.max(max, num), 0);
    };

    toRadians(degrees){
        return degrees * (Math.PI / 180);
    }
}

const utilsInstance = new Utils();

Object.freeze(utilsInstance);

export default utilsInstance;